import { QrTypes } from "../../../../qr/enums";
import { ReactComponent as ScanIcon } from "../assets/scan.svg";
import { ReactComponent as ScanSuccessIcon } from "../assets/scan-granted.svg";
import { ReactComponent as ScanFailIcon } from "../assets/scan-denied.svg";

type Props = {
  status: QrTypes;
};

export const StaffOverrideStatusContent = ({ status }: Props) => {
  if (status === QrTypes.SUCCESS) {
    return <ScanSuccessIcon data-testid="scan-success-icon" />;
  }

  if (status === QrTypes.ERROR) {
    return <ScanFailIcon data-testid="scan-error-icon" />;
  }

  return <ScanIcon data-testid="scan-scanning-icon" />;
}
